export const darkColors = {
  primary: '#C9A843',
  primaryDark: '#A8883A',
  primaryLight: '#D4B45A',
  accent: '#C9A843',
  background: '#0D1B2A',
  surface: '#152232',
  surfaceAlt: '#1A2840',
  text: '#F8FAFC',
  textMuted: 'rgba(248,250,252,0.55)',
  textOnPrimary: '#FFFFFF',
  success: '#34D399',
  danger: '#F87171',
  warning: '#FBBF24',
  border: 'rgba(201,168,67,0.20)',
  borderStrong: 'rgba(201,168,67,0.38)',
  /** Χαρακτηριστικό aqua/petrol για ό,τι φαίνεται μόνο επειδή έχεις ενεργό
   * επαγγελματικό λογαριασμό — ώστε να ξεχωρίζει οπτικά από τα γενικά (χρυσά)
   * στοιχεία. */
  professional: '#6366F1',
} as const;

export const lightColors = {
  primary: '#C9A843',
  primaryDark: '#A8883A',
  primaryLight: '#B8962E',
  accent: '#C9A843',
  background: '#F8FAFC',
  surface: '#FFFFFF',
  surfaceAlt: '#F1F5F9',
  text: '#1F2937',
  textMuted: '#6B7280',
  textOnPrimary: '#FFFFFF',
  success: '#059669',
  danger: '#DC2626',
  warning: '#D97706',
  border: 'rgba(30,58,138,0.15)',
  borderStrong: 'rgba(30,58,138,0.30)',
  /** Χαρακτηριστικό aqua/petrol για ό,τι φαίνεται μόνο επειδή έχεις ενεργό
   * επαγγελματικό λογαριασμό — ώστε να ξεχωρίζει οπτικά από τα γενικά (χρυσά)
   * στοιχεία. */
  professional: '#4F46E5',
} as const;

export type AppColors = { [K in keyof typeof darkColors]: string };

// Backward-compat: default dark — components που δεν χρησιμοποιούν useTheme()
export const colors = darkColors;

/** Χαρακτηριστικό aqua του chat εικονιδίου/λειτουργίας — ίδιο και στα δύο
 * θέματα (dark/light), σταθερό branding χρώμα ανεξάρτητα από colors.primary. */
export const CHAT_AQUA = '#2AABEE';

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
} as const;

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  full: 999,
} as const;

export const fontSize = {
  xs: 11,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 28,
  xxl: 34,
} as const;

export const shadow = {
  card: {
    boxShadow: '0px 2px 12px rgba(0,0,0,0.45)',
    elevation: 4,
  },
} as const;

/**
 * Μέγιστο πλάτος περιεχομένου σε μεγάλες οθόνες (desktop web, tablet).
 *
 * Φόρμες και στήλες κειμένου γίνονται δυσανάγνωστες όταν τεντώνονται σε όλο
 * το πλάτος — το μάτι χάνει τη γραμμή. Τα screens τα εφαρμόζουν στο
 * contentContainer τους με `width: '100%'` + `alignSelf: 'center'`, ώστε σε
 * κινητό (που είναι ήδη στενότερο) να μην αλλάζει τίποτα.
 */
export const contentMaxWidth = {
  /** Φόρμες σύνδεσης/εγγραφής, κάρτες πρόσκλησης. */
  form: 460,
  /** Οθόνες με περισσότερο περιεχόμενο (προφίλ, συνομιλία, λίστες). */
  wide: 720,
} as const;
